import request from '@/utils/request'


export function GetBranchFoods(branchId) {
    return request({
        url: '/Food/GetBranchFoods',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SaveFood(id, branchId, name, description, file) {

    var fmData = new FormData();

    fmData.append("BranchId", parseInt(branchId));
    fmData.append("Id", id);
    fmData.append("Name", name);
    fmData.append("Description", description);
    fmData.append("File", file);



    return request({
        url: '/Food/Save',
        method: 'post',
        data: fmData,
    });
}



export function DeleteFood(id) {
    return request({
        url: '/Food/Delete',
        method: 'post',
        data: {
            Id: id,

        }

    })
}